import React, { useState } from 'react';
import ApiService from '../Services/ApiService';

const useActualizarNewsletter = () => {
    const { REACT_APP_APILOGIN } = process.env;
    const [isLoading, setIsLoading] = useState(null);
    const [responseActualizar, dataObtenerServicios] = useState(null);
    const [error, setError] = useState(null);

    const outFunc = async (payload) => {
        setIsLoading(true);
        ApiService.post(`${REACT_APP_APILOGIN}NewslettersV1/Actualizar`, {servicios_ids: payload.join(',')})
            .then((data) => {
                if (data && data.code === '0') {
                    dataObtenerServicios(data.response);
                    setIsLoading(false);
                } else {
                    setError(data.message);
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                setError(error);
                setIsLoading(false);
            });
    };

    return [responseActualizar, error, isLoading, outFunc];
};

export default useActualizarNewsletter;